import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { getMinistries, getReimbursements } from '../services/api';
import { formatAccountingCurrency } from '../utils/formatters';
import './Dashboard.css';

const Dashboard = ({ selectedYear, onYearChange }) => {
  const { isAdmin } = useAuth();
  const [ministries, setMinistries] = useState([]);
  const [pendingReimbursements, setPendingReimbursements] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadData();
  }, [selectedYear]);

  const loadData = async () => {
    try {
      setLoading(true);
      const [ministriesRes, reimbursementsRes] = await Promise.all([
        getMinistries(selectedYear),
        isAdmin ? getReimbursements({ status: 'pending' }) : Promise.resolve({ data: [] })
      ]);
      
      setMinistries(ministriesRes.data);
      setPendingReimbursements(reimbursementsRes.data);
    } catch (error) {
      console.error('Erro ao carregar dados:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="loading">Carregando...</div>;
  }

  return (
    <div className="dashboard-page">
      <div className="container">
        <div className="dashboard-header">
          <h1>Dashboard - Tesouraria {selectedYear}</h1>
        </div>

        {isAdmin && pendingReimbursements.length > 0 && (
          <div className="card pending-alert">
            <h3>Reembolsos Pendentes de Aprovação</h3>
            <p>{pendingReimbursements.length} reembolso(s) aguardando sua aprovação</p>
            <Link to="/reimbursements?status=pending" className="btn btn-primary btn-sm">
              Ver Reembolsos Pendentes
            </Link>
          </div>
        )}

        <div className="ministries-grid">
          {ministries.length === 0 ? (
            <div className="card text-center">
              <p>Nenhum ministério cadastrado.</p>
              {isAdmin && (
                <Link to="/admin/ministries" className="btn btn-primary">
                  Adicionar Ministério
                </Link>
              )}
            </div>
          ) : (
            ministries.map((ministry) => (
              <Link 
                key={ministry._id} 
                to={`/ministry/${ministry._id}`}
                className="ministry-card"
              >
                <div className="ministry-card-header">
                  <div className="ministry-card-title">
                    {ministry.logoUrl ? (
                      <img src={ministry.logoUrl} alt="" className="ministry-card-logo" />
                    ) : (
                      <span className="ministry-card-logo-fallback">
                        <i className="fas fa-church"></i>
                      </span>
                    )}
                    <h3>{ministry.name}</h3>
                  </div>
                  <span className={`ministry-balance ${ministry.currentBalance < 0 ? 'text-negative' : 'text-positive'}`}>
                    {formatAccountingCurrency(ministry.currentBalance)}
                  </span>
                </div>
                <div className="ministry-card-body">
                  <p className="ministry-leader">
                    <span className="ministry-leader-label">Líder:</span> {ministry.leader.name}
                  </p>
                </div>
              </Link>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
